import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dea56281a098ba/components/sections/BranchSolutionsShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dea56281a098ba/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dea56281a098ba/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dea56281a098ba/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dea56281a098ba/components/sections/UseCasesCarousel.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/sections/SourcesSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/app/[locale]/branchen/shared-branch.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dea56281a098ba/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
